<template>
  <e-chart
    ref="chart"
    :key="chartKey"
    :options="chartOptions"
    autoresize
    style="height: 400px; width: 520px;"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/graphic'
import { capitalizeFirstLetter } from '@/composables/useCapitalizeFirstLetter.js'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    'e-chart': ECharts,
  },
  data: () => ({
    chartKey: 1,
  }),
  watch: {
    items: {
      handler() {
        this.chartKey += 1
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    chartOptions() {
      return {
        // tooltip: {
        //   trigger: 'item',
        //   formatter: ({ data }) => {
        //     let str = ''
        //     data.items.forEach(item => {
        //       str += `${item.name}: <b>${item.value}</b><br>`
        //     })
        //     return str
        //   },
        // },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          icon: 'roundRect',
          textStyle: {
            fontSize: 16,
            color: '#333',
            textTransform: 'capitalize',
          },
          itemWidth: 14,
          itemHeight: 14,
          data: this.items.map(i => i.name),
          formatter: (status) => {
            return capitalizeFirstLetter(status)
          },
        },
        graphic: [
          {
            id: 'center-text',
            type: 'text',
            left: 'center',
            top: 'middle',
            z: 1,
            style: {
              text: `Total ${this.items.reduce((sum, item) => {
                return sum + item.items.reduce((sumItemsValue, el) => {
                  return sumItemsValue + el.value
                }, 0)
              }, 0)}`,
              textAlign: 'center',
              fill: '#333',
              font: 'bold 18px sans-serif',
            },
          },
        ],
        series: [
          {
            name: 'Status',
            type: 'pie',
            radius: ['50%', '70%'],
            minAngle: 5,
            avoidLabelOverlap: false,
            z: 10,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
              formatter: ({ data }) => {
                let str = ''
                data.items.forEach((item, index) => {
                  str += `${item.name}: ${item.value}${data.items.length === index + 1 ? '' : '\n'}`
                })
                return str
              },
            },
            emphasis: {
              label: {
                backgroundColor: '#fff',
                padding: [10, 20],
                show: true,
                fontSize: '18',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: this.items,
          },
        ],
      }
    },
  },
  methods: {
    onLegendClick(params) {
      this.$emit('legendClick', params.name)
    },
    onChartClick(params) {
      if (params.componentType === 'series' && params.seriesType === 'pie') {
        this.$emit('chartClick', { name: params.name, value: params.value })
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const chart = this.$refs.chart && this.$refs.chart.chart
      if (chart) {
        chart.on('legendselectchanged', this.onLegendClick)
        chart.on('click', this.onChartClick)
      }
    })
  },
  beforeDestroy() {
    const chart = this.$refs.chart && this.$refs.chart.chart
    if (chart) {
      chart.off('legendselectchanged', this.onLegendClick)
      chart.off('click', this.onChartClick)
    }
  },
}
</script>
